export interface IReconciliationAsset {
  asset_code: string;
  issuer: string;
}

export enum EReconciliationStatus {
  AwaitingPayment = 'awaiting_payment',
  Overdue = 'overdue',
  Calculation = 'calculation',
  Calculated = 'calculated',
  AwaitingConfirmation = 'awaiting_confirmation',
  Appeal = 'appeal',
  Draft = 'draft',
  Confirmed = 'confirmed',
  Error = 'error',
}

export type TReconciliationStatusKind = (typeof EReconciliationStatus)[keyof typeof EReconciliationStatus];

export interface IReconciliationCalculations {
  amount_reserve_account: number;
  reserve_acc_currency: string;
  saldo: number;
  total_in: number;
  total_out: number;
}

export interface IReconciliationErrorMessage {
  error: string;
}

export interface IReconciliationGetParticipantsResponse {
  participants: IReconciliationParticipant[] | null;
  total: number;
}

export interface IReconciliationGetReconciliationsResponse {
  recons: IReconciliationEntity[] | null;
  total: number;
}

export interface IReconciliationSetStatusReqBody {
  status: EReconciliationStatus;
}

export interface IReconciliationParticipant {
  balance_after: number;
  balance_before: number;
  central_reserve: number;
  guid: string;
  is_blocked: boolean;
  name: string;
  saldo: number;
  total_in: number;
  total_out: number;
  participant_type?: string;
  debtor_guid?: string;
}

export interface IReconciliationEntity {
  asset: IReconciliationAsset;
  calculations: IReconciliationCalculations;
  created_at: string;
  creditor: IReconciliationParticipant;
  debtor: IReconciliationParticipant;
  end_date: string;
  guid: string;
  overdue_days: number;
  start_date: string;
  status: EReconciliationStatus;
  updated_at: string;
}

export interface IReconciliationUpdateRequest {
  status: EReconciliationStatus;
}

export enum EReconciliationParticipantType {
  Creditor = 'creditor',
  Debtor = 'debtor',
}

export type TReconciliationListReqParams = {
  guid?: string[];
  start_date?: number;
  end_date?: number;
  status?: EReconciliationStatus[];
  asset_code?: string;
  asset_issuer?: string;
  creditor_counterparty_guid?: string;
  debtor_counterparty_guid?: string;
  limit?: number;
  offset?: number;
  order?: string;
};
export type TReconciliationCounterpartyListReqParams = {
  guid?: string[];
  start_date?: number;
  end_date?: number;
  status?: EReconciliationStatus[];
  asset_guid?: string;
  counterparty_role: EReconciliationParticipantType;
  participant_counterparty_guid?: string;
  limit?: number;
  offset?: number;
  order?: string;
};

export type TReconciliationParticipantsListReqParams = {
  guid?: string[];
  counterparty_role: EReconciliationParticipantType;
  start_date?: number;
  end_date?: number;
  status?: EReconciliationStatus[];
  asset_guid?: string;
  limit?: number;
  offset?: number;
  order?: string;
};

export type TReconciliationCounterpartyParticipantsListReqParams = {
  guid?: string[];
  counterparty_role: EReconciliationParticipantType;
  start_date?: number;
  end_date?: number;
  status?: EReconciliationStatus[];
  asset_guid?: string;
  limit?: number;
  offset?: number;
  order?: string;
};

export type TTablePaginationConfig = {
  page: number;
  pageSize: number;
};
